<div *ngIf="!loading" class="flex flex-col h-full">
    <div class="items-start general-container">
        <div class="container header">
            <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px] text-center bg-gradient-2-text">E-mail</h2>
            <p class="font-sans text-center text-xl text-gray-40">{{ 'pwd.recover' | translate }} {{ 'REGISTER.PWD_MAX_LENGTH' | translate }}.</p>
        </div>
        <div class="input-container">
            <form [formGroup]="passwordForm">
                <div class="row">
                    <div class="col-12 flex flex-col gap-16">
                         <fun-input
                         placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
                         [parentForm]="passwordForm"
                         [formControlKeys]="formControlKeys"
                         [errorMessages]="errorMessages"
                         [isSubmit]="isSubmit"
                         controlName="pwd1"
                         type="password"
                         [errorLogin]="errorPwd1"
                         labelName="{{ 'LOGIN.PASSWORD' | translate }}"
                          ></fun-input>
                          <fun-input
                          class="second-inp"
                          placeholder="{{ 'pwd.new_pwd' | translate }}"
                          [parentForm]="passwordForm"
                          [formControlKeys]="formControlKeys"
                          [errorMessages]="errorMessages"
                          [isSubmit]="isSubmit"
                          controlName="pwd2"
                          type="password"
                          [errorLogin]="errorPwd2"
                          labelName="{{ 'pwd.new_pwd' | translate }}"
                           ></fun-input>
                           <fun-input
                          class="second-inp"
                          placeholder="{{ 'pwd.repeat_pwd' | translate }}"
                          [parentForm]="passwordForm"
                          [formControlKeys]="formControlKeys"
                          [errorMessages]="errorMessages"
                          [isSubmit]="isSubmit"
                          controlName="pwd3"
                          type="password"
                          [errorLogin]="errorPwd3"
                          labelName="{{ 'pwd.repeat_pwd' | translate }}"
                           ></fun-input>
                    </div>
                </div>
            </form>
            <p class="font-sans pt-6 text-m text-eggplant-100/[0.4] hover:cursor-pointer hover:underline hover:underline-offset-6" (click)="forgotPwd()">{{ 'pwd.forgoten' | translate }}</p>
        </div>
    </div>

    <div class="footer flex py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row justify-end md:border-t md:border-eggplant-10" *ngIf="!loading">
        <div class="w-full md:w-fit flex justify-center content-center">
            <fun-new-button [buttonType]="btnType" icon="arrow-right" [iconPosition]="'right'" [classExtra]="' !w-full '" class="w-full md:w-fit ml-auto"
            title="{{ 'btn.send' | translate }}" size="xl" (eventClick)="submit()" [iconVibibleMobile]="false" [responsive]="false"></fun-new-button>
        </div>
    </div>
</div>

<div class="spinner" *ngIf="loading">
    <fun-spinner></fun-spinner>
</div>
